module.exports = __webpack_public_path__ + "img/fish.37b9d5f7.svg";